import * as Sentry from "@sentry/react";
import { useInsights } from "../../hooks/useInsights";

function RecomendacionesInsightsInner() {
  const userId = (typeof window !== "undefined" && window.__USER_ID__) || "guest";
  const { recommendations, loading } = useInsights(userId);

  if (loading || !recommendations) {
    return (
      <div className="insights-panel">
        <h2 className="insights-title">Recomendaciones</h2>
        <p className="insights-subtitle">Cargando datos…</p>
      </div>
    );
  }

  const suggestions = recommendations.suggestions || [];

  return (
    <div className="insights-panel">
      <h2 className="insights-title">Recomendaciones</h2>
      <p className="insights-subtitle">
        Sugerencias personalizadas basadas en tu actividad reciente.
      </p>

      <div className="insights-grid">
        {suggestions.map((text, i) => (
          <div className="insights-card" key={i}>
            <h3>Sugerencia {i + 1}</h3>
            <p>{text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

const RecomendacionesInsights = Sentry.withErrorBoundary(RecomendacionesInsightsInner, {
  fallback: (
    <div className="insights-panel" data-testid="recomendaciones-insights-error">
      <h2 className="insights-title">Recomendaciones</h2>
      <p className="insights-subtitle">
        Ha ocurrido un error al cargar las recomendaciones. El equipo ya fue notificado.
      </p>
    </div>
  ),
});

export default RecomendacionesInsights;
